<template>
  <div class="uk-position-relative">
    <div
      class="arrow arrow-left triangle cursor-pointer"
      @click="$refs.caro.prev()"
      v-if="list.length > 1"
    ></div>
    <el-carousel
      height="50px"
      :autoplay="false"
      arrow="never"
      indicator-position="none"
      ref="caro"
    >
      <el-carousel-item v-for="(item, index) in list" :key="index">
        <div class="card-swiper border uk-text-center r-default">
          <div class="color-white" :class="bgColor">
            <TextTooltip>
              <slot name="title" :item="item" :index="index">
                {{ item.title }}
              </slot>
            </TextTooltip>
          </div>

          <div class="uk-position-relative">
            <template v-if="$slots.default">
              {{ item.text }}
            </template>
            <slot v-else :item="item" :index="index"></slot>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>

    <div
      class="arrow arrow-right triangle cursor-pointer"
      @click="$refs.caro.next()"
      v-if="list.length > 1"
    ></div>
  </div>
</template>

<script>
// import Tooltip from '@/pages/system/resource/components/tooltip.vue'
import TextTooltip from '@/pages/system/resource/components/tooltip.vue'

export default {
  components: { TextTooltip },
  props: {
    /**
     * ListItem { Object }
     * title  项的标题
     * text   描述文本
     */
    list: {
      type: Array,
      default: () => []
    },
    emptyText: {
      type: String,
      default: ''
    },
    bgColor: {
      type: String,
      default: 'bg-theme'
    }
  }
}
</script>

<style lang="scss" scoped>
$triangle-size: 8px;

.card-swiper {
  .title {
    background-color: $theme-color;
  }
}

.arrow {
  position: absolute;
  margin-top: 15px;

  top: 0;
}

.arrow-right {
  right: -17px;

  border-color: transparent transparent transparent var(--primary-color);
}

.arrow-left {
  left: -17px;
  border-color: transparent var(--primary-color) transparent transparent;
}

.triangle {
  border-style: solid;
  border-width: $triangle-size;
}
</style>
